import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { StorageProvider } from '../../providers/storage/storage';
import { AssetProvider } from '../../providers/asset/asset';
import { Asset } from '../../interfaces/asset.model';
import { FilterProvider } from '../../providers/filter/filter';
import { LanguageProvider } from '../../providers/language/language';
import { Language } from '../../interfaces/language.model';

@IonicPage()
@Component({
  selector: 'page-fil-rouge',
  templateUrl: 'fil-rouge.html',
})
export class FilRougePage {

  assets: Asset[];
  filterType: string;
  selectedLanguage: Language;
  languages: Language[];
  displayAsList: boolean;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    public translate: TranslateService, 
    public storageService: StorageProvider, 
    public assetService: AssetProvider,
    public filterService: FilterProvider,
    public languageService: LanguageProvider) 
  {
    this.filterType = "asc";
    this.displayAsList = false;
    this.setSelectedLanguage();
  }

  ionViewDidLoad() {
    this.getfilterAssets();
    this.languages = this.languageService.getAllLanguages();
    this.getDisplayListView();
  }

  /* LIST VIEW */

  getDisplayListView(){
    this.storageService.getDataStorage("displayAsList").then(displayListView => {
      if(displayListView !== null){
        this.displayAsList = displayListView;
      } else {
        this.displayAsList = false;
      }
    });
  }

  updateListView(){
    this.displayAsList = !this.displayAsList;
    this.storageService.setDataStorage("displayAsList", this.displayAsList);
  }

  setSelectedLanguage(){
    this.languageService.getSelectedLang().then(selectedLanguage => {
      if(selectedLanguage == null){
        this.selectedLanguage = this.languages[0];
        this.languageService.setSelectedLang(this.selectedLanguage.LanguageCode);
      } else {
        this.selectedLanguage = this.languages.find(lang => lang.LanguageCode == selectedLanguage);
      }
    }).catch(error => this.selectedLanguage = this.languages[0]);
  }

  getfilterAssets() {
    this.filterService.filterAssets().then(assets => {
      this.assets = assets;
      this.filterAssetsFilRouge();
    });
  }

  filterAssetsFilRouge(){
    if(this.assets && this.assets.length > 0){
      this.assets = this.assets.filter(item => item.IsFilRouge == true);
    }
  }

  updateAssets() {
    this.getfilterAssets();
  }

  updateFilter(value){
    this.filterType = value;
  }

}



// WEBPACK FOOTER //
// ./src/pages/fil-rouge/fil-rouge.ts